import styled from 'styled-components';

import colors from 'styles/colors';
import { tabActiveStyles, tabBaseStyles } from 'styles/tabStyles';
import FlexDiv from 'components/FlexDiv';

export const StyledTab = styled.div<{ active: boolean }>`
  ${tabBaseStyles};
  ${({ active }) => active && tabActiveStyles};
`;

export const TabsContainer = styled(FlexDiv)`
  gap: 24px;
  padding: 8px 24px;
`;

export const Star = styled.button`
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 24px 32px;
  min-width: 280px;

  h3 {
    margin: 0;
    color: ${colors.brand_2};
  }
`;

export const SchoolList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SchoolItem = styled.li`
  label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
  }
`;

export const ModalButtons = styled(FlexDiv)`
  gap: 16px;
  justify-content: center;
  margin-top: 8px;
`;
